import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import {
  initiateStudentDeletion,
  initiateTeacherDeletion,
  initiateFullDeletion,
} from '@/services/accountDeletionService';

export function useInitiateStudentDeletion() {
  const auth = useAuth();

  return useMutation({
    mutationFn: async () => {
      const token = await auth.getToken();
      return initiateStudentDeletion(token);
    },
  });
}

export function useInitiateTeacherDeletion() {
  const auth = useAuth();

  return useMutation({
    mutationFn: async () => {
      const token = await auth.getToken();
      return initiateTeacherDeletion(token);
    },
  });
}

export function useInitiateFullDeletion() {
  const auth = useAuth();

  return useMutation({
    mutationFn: async () => {
      const token = await auth.getToken();
      return initiateFullDeletion(token);
    },
  });
}
